export default __webpack_public_path__ + "static/media/MP_Round_White_Top_1.3cd1d78d.jpeg";